import { useEffect, useState } from "react";
import CustomButton from "../button/Button";
import Modal from "../modal/Modal";
import "./VariantView.css";
import TextInput from "../TextInput";
import { TextareaAutosize } from "@mui/material";
import { toast } from "react-toastify";
import { poExceptionVariantsEndpoint } from "../../../common/endpoints";
import { postCreateNewVariant } from "../../../redux/actions/VariantView/NewVariantSlice";
import { useSelector, useDispatch } from "react-redux";
import { getVariantsList } from "../../../redux/actions/VariantView/GetVariantsListSlice";
import { editVariantAPI } from "../../../redux/actions/VariantView/EditVariantSlice";
import { Box, CircularProgress } from "@mui/material";

export const VariantViewModal = ({ openCreateVariantModal, handleCloseCreateVariantModal, data, tableType, appCode = "SC", plant, region }) => {
    const dispatch = useDispatch();
    const [variantSelection, setVariantSelection] = useState("");
    const [variantsResponse, setVariantsResponse] = useState("");
    const [formDataModal, setFormDataModal] = useState({});
    const [variantsData, setVariantsData] = useState([])
    const onCloseVariantModal = () => {
        setVariantSelection("");
        handleCloseCreateVariantModal();
    }
    const onClickCancel = () => {
        handleCloseCreateVariantModal();
        setVariantSelection("");
    }
    const getVariantsData = async () => {
        try {
            const responseGetVariants = await dispatch(getVariantsList({
                dynamicEndpoint: `${poExceptionVariantsEndpoint}`,
                params: {
                    tableType: tableType,
                    plant: plant,
                    appCode: appCode,
                    region: region
                }
            }));
            if (responseGetVariants?.meta?.requestStatus === 'fulfilled') {
                setVariantsResponse(responseGetVariants?.payload)
                setVariantsData(responseGetVariants?.payload?.variants)
            } else {
                console.error('Failed to fetch data:', responseGetVariants?.error);
                toast.error(responseGetVariants?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }
    }

    useEffect(() => {
        openCreateVariantModal === true && getVariantsData();
    }, [openCreateVariantModal]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCreateNewVariant = async () => {
        const userEmail = localStorage.getItem("userEmail");
        const filterData = data;
        const reqBodyCreateVariant = {
            "userEmail": userEmail,
            "tableType": tableType,
            "plant": plant,
            "region": region,
            "variantName": formDataModal?.variantName,
            "variantDescription": formDataModal?.variantDesc,
            "filterJson": JSON.stringify(filterData),
            "appCode": appCode  
        }
        try {
            const response = await dispatch(
                postCreateNewVariant({
                    dynamicEndpoint: `${poExceptionVariantsEndpoint}`,
                    data: reqBodyCreateVariant
                })
            );
            if (response?.meta?.requestStatus === "fulfilled") {
                toast.success(response?.payload?.message, {
                    autoClose: 2000,
                });
                onCloseVariantModal();
            } else {
                toast.error(response?.payload?.errorMessage, {
                    autoClose: 3000,
                });
            }
        } catch (error) {
            console.error("API error:", error);
        }

    }
    const handleModifyVariant = () => {
        onCloseVariantModal()
    }
    const onClickVariantSelection = (name) => {
        setVariantSelection(name)
    }
    const getCreateFormData = (formData) => {
        setFormDataModal(formData)
    }
    const onClickReplaceAPI = () => {

    }

    return (
        <>
            <Modal
                className="createVariantModal_cls"
                open={openCreateVariantModal}
                handleClose={onCloseVariantModal}
                title="Variants Catalog"
                fullWidth={true}
                // maxWidth="xs"
                action={
                    <CreateVariantFooter
                        handleCreateNewVariant={handleCreateNewVariant}
                        handleModifyVariant={handleModifyVariant}
                        onClickCancel={onClickCancel}
                        variantSelection={variantSelection}
                        formDataModal={formDataModal}

                    />
                }
                content={
                    <CreateVariantContent
                        onClickVariantSelection={onClickVariantSelection}
                        variantSelection={variantSelection}
                        data={data}
                        getCreateFormData={getCreateFormData}
                        isLimitReached={variantsResponse?.isLimitReached}
                        limitCount={variantsResponse?.limitCount}
                        variantsData={variantsData}
                        onClickReplaceAPI={onClickReplaceAPI}
                        onClickCancel={onClickCancel}
                    />
                }
            />
        </>
    )
}

const CreateVariantFooter = ({ formDataModal, variantSelection, onClickCancel, handleCreateNewVariant, onClickModifyVariant }) => {

    return (
        variantSelection === "new" ?
            <div className='finalLTupdatedfooter-warning-btn-wrapper'>
                <CustomButton
                    label="Cancel"
                    type="primary"
                    maxWidth="80px"
                    onClick={onClickCancel}
                />
                <CustomButton
                    label="Create"
                    type="secondary"
                    maxWidth="80px"
                    onClick={handleCreateNewVariant}
                    disabled={!formDataModal?.variantDesc || !formDataModal?.variantName}
                />
            </div>
            :
            variantSelection === "modify" ?
                <div className='finalLTupdatedfooter-warning-btn-wrapper'>
                    <CustomButton
                        label="Cancel"
                        type="primary"
                        maxWidth="80px"
                        onClick={onClickCancel}
                    />
                </div>
                :
                <div className='finalLTupdatedfooter-btn-wrapper'>
                    <CustomButton
                        label="Cancel"
                        type="primary"
                        maxWidth="80px"
                        onClick={onClickCancel}
                    />
                </div>
    );
};
const CreateVariantContent = ({ onClickVariantSelection, variantSelection, getCreateFormData, isLimitReached, onClickReplaceAPI, variantsData, data, onClickCancel, limitCount }) => {
    const stateSelector = useSelector((state) => state); // eslint-disable-line no-unused-vars
    const NewVariantSlice = useSelector((state) => state.NewVariantSlice);
    const EditVariantSlice = useSelector((state) => state.EditVariantSlice);
    const GetVariantsListSlice = useSelector((state) => state.GetVariantsListSlice);
    const isLoading =
        NewVariantSlice?.loading ||
        EditVariantSlice?.loading ||
        GetVariantsListSlice?.loading;

    return (
        isLoading ?
            <Box style={{ textAlign: 'center', height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress color="inherit" style={{ width: '20px', height: '20px', textAlign: 'center', marginRight: 30 }} />
            </Box>
            :
            <>
                {variantSelection === "new" ?
                    <CreateNewVariantComponent getCreateFormData={getCreateFormData} /> :
                    variantSelection === "modify" ?
                        <ModifyVariantComponent data={data} variantsData={variantsData} onClickReplaceAPI={onClickReplaceAPI} onClickCancel={onClickCancel} /> :
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
                            <p>Note:  You can create a maximum of {limitCount} variants.  </p>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
                                <CustomButton
                                    label="Create New Variant"
                                    type="secondary"
                                    maxWidth="200px"
                                    onClick={() => onClickVariantSelection("new")}
                                    disabled={isLimitReached || !data || Object.keys(data).length === 0}
                                />
                                <CustomButton
                                    label="Edit Variant"
                                    type="secondary"
                                    maxWidth="150px"
                                    onClick={() => onClickVariantSelection("modify")}
                                    disabled={!data || Object.keys(data).length === 0}
                                />
                            </div>
                            {(!data || Object.keys(data).length === 0) && (
                                <p style={{ color: "red", marginBottom: "8px" }}>
                                    Please select filters to create variant
                                </p>
                            )}
                        </div >
                }
            </>
    )
};

const CreateNewVariantComponent = ({ getCreateFormData }) => {

    const [formData, setFormData] = useState({ variantName: "", variantDesc: "" })
    const onChangeVariant = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

        getCreateFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    }

    return (
        <div>
            <div style={{ display: 'flex', }}>
                <p style={{ flex: 1 }}>Variant Name</p>
                <div style={{ flex: 3 }}>
                    <TextInput
                        name="variantName"
                        value={formData?.variantName}
                        onChange={onChangeVariant}
                        style={{ width: '100%', fontFamily: 'sans-serif', fontSize: 15 }}
                    />
                </div>
            </div>
            <div style={{ display: 'flex', }}>
                <p style={{ flex: 1 }}>Variant Description</p>
                <div style={{ flex: 3 }}>
                    <TextareaAutosize
                        minRows={6}
                        style={{ width: '99%', fontFamily: 'sans-serif', fontSize: 16, padding: 10 }}
                        name="variantDesc"
                        value={formData?.variantDesc}
                        onChange={onChangeVariant}
                    />
                </div>
            </div>
        </div>
    )
}

const ModifyVariantComponent = ({ variantsData, data, onClickCancel }) => {
    const userEmail = localStorage.getItem("userEmail");
    const dispatch = useDispatch();
    const [isEditClicked, setIsEditClicked] = useState(false);
    const [editFormData, setEditFormData] = useState({ variantName: "", variantDesc: "" });

    const onClickEditButton = (item) => {
        setIsEditClicked(true);
        setEditFormData({
            variantName: item.variantName,
            variantDesc: item.variantDescription,
            userVariantMapSeqId: item.userVariantMapSeqId
        })
    }
    const onChangeEditFormData = (e) => {
        setEditFormData({
            ...editFormData,
            [e.target.name]: e.target.value
        })
    }

    const onClickBackFromEditMode = () => {
        setIsEditClicked(false)
    }
    const onClickUpdateAPI = async () => {
        const reqBodyReplaceVariant = {
            "userEmail": userEmail,
            "variantName": editFormData.variantName || "",
            "variantDescription": editFormData.variantDesc || "",
            "filterJson": JSON.stringify(data),
            "modifiedBy": userEmail,
        }
        try {
            const response = await dispatch(
                editVariantAPI({
                    dynamicEndpoint: `${poExceptionVariantsEndpoint}/${editFormData.userVariantMapSeqId}`,
                    params: { role: localStorage.getItem("userRole") },
                    data: reqBodyReplaceVariant
                })
            );
            if (response?.meta?.requestStatus === "fulfilled") {
                onClickCancel();
                toast.success(response?.payload, {
                    autoClose: 2000,
                });
            } else {
                toast.error(response?.payload?.errorMessage, {
                    autoClose: 3000,
                });
            }
        } catch (error) {
            console.error("API error:", error);
        }
    }
     return (
        isEditClicked ?
            <div>
                <div>
                    <div style={{ display: 'flex', }}>
                        <p style={{ flex: 1 }}>Variant Name</p>
                        <div style={{ flex: 3 }}>
                            <TextInput
                                name="variantName"
                                value={editFormData?.variantName}
                                onChange={onChangeEditFormData}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', }}>
                        <p style={{ flex: 1 }}>Variant Description</p>
                        <div style={{ flex: 3 }}>
                            <TextareaAutosize
                                minRows={6}
                                style={{ width: '99%' }}
                                name="variantDesc"
                                value={editFormData?.variantDesc}
                                onChange={onChangeEditFormData}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginTop: 10 }}>
                    <CustomButton
                        label="Back"
                        type="primary"
                        maxWidth="80px"
                        onClick={onClickBackFromEditMode}
                    />
                    <CustomButton
                        label="Update"
                        type="secondary"
                        maxWidth="100px"
                        onClick={onClickUpdateAPI}
                    />
                </div>
            </div>
            :
            <div>
                <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px" }}>
                    <thead>
                        <tr style={{ backgroundColor: "#f5f5f5" }}>
                            <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "200px" }}>Variant Name</th>
                            <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "350px" }}>Variant Description</th>
                            <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>Created On</th>
                            <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>Modified On</th>
                            <th style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left" }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {variantsData.map((item) => (
                            <tr key={item?.userVariantMapSeqId}>
                                <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "200px" }}>{item?.variantName}</td>
                                <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "350px" }}>{item?.variantDescription}</td>
                                <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>{item?.createdAt}</td>
                                <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "left", whiteSpace: "normal", wordBreak: "break-word", maxWidth: "150px" }}>{item?.modifiedAt}</td>
                                <td style={{ border: "1px solid #bcbcbc", padding: "8px", textAlign: "center" }}>
                                    <CustomButton
                                        label="Edit"
                                        type="secondary"
                                        maxWidth="100px"
                                        onClick={() => onClickEditButton(item)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
    )
}